"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeavyVehicleFlowType = exports.SpeedDifferentialType = exports.SpeedAverageType = exports.ProportionOfCargoBikesAndMopedsType = exports.BicycleAndLVFlowType = exports.PedestrianFlowType = exports.NumberOfLanesType = exports.IntersectionApproachType = exports.CurvatureType = exports.GradeType = exports.FlowDirectionType = exports.FacilityWidth = exports.PresenceType = exports.AdequateType = exports.FacilityType = exports.AreaType = exports.getOptionTranslation = void 0;
const getOptionTranslation = (value) => `sdk:attribute.option.${value}`;
exports.getOptionTranslation = getOptionTranslation;
var AreaType;
(function (AreaType) {
    AreaType["InnerUrban"] = "InnerUrban";
    AreaType["OtherUrban"] = "OtherUrban";
    AreaType["Rural"] = "Rural";
    AreaType["Industrial"] = "Industrial";
})(AreaType || (exports.AreaType = AreaType = {}));
var FacilityType;
(function (FacilityType) {
    FacilityType["Sidewalk"] = "Sidewalk";
    FacilityType["MultiUsePath"] = "MultiUsePath";
    FacilityType["OffRoadBicyclePath"] = "OffRoadBicyclePath";
    FacilityType["OnRoadBicycleLane"] = "OnRoadBicycleLane";
    FacilityType["RoadShoulder"] = "RoadShoulder";
    FacilityType["MixedTrafficRoadLane"] = "MixedTrafficRoadLane";
})(FacilityType || (exports.FacilityType = FacilityType = {}));
var AdequateType;
(function (AdequateType) {
    AdequateType["Adequate"] = "Adequate";
    AdequateType["Inadequate"] = "Inadequate";
})(AdequateType || (exports.AdequateType = AdequateType = {}));
var PresenceType;
(function (PresenceType) {
    PresenceType["Present"] = "Present";
    PresenceType["NotPresent"] = "NotPresent";
})(PresenceType || (exports.PresenceType = PresenceType = {}));
var FacilityWidth;
(function (FacilityWidth) {
    FacilityWidth["VeryNarrow"] = "VeryNarrow";
    FacilityWidth["Narrow"] = "Narrow";
    FacilityWidth["Wide"] = "Wide";
})(FacilityWidth || (exports.FacilityWidth = FacilityWidth = {}));
var FlowDirectionType;
(function (FlowDirectionType) {
    FlowDirectionType["OneWay"] = "OneWay";
    FlowDirectionType["TwoWay"] = "TwoWay";
})(FlowDirectionType || (exports.FlowDirectionType = FlowDirectionType = {}));
var GradeType;
(function (GradeType) {
    GradeType["LessThan5degrees"] = "LessThan5degrees";
    GradeType["MoreThan5degrees"] = "MoreThan5degrees";
})(GradeType || (exports.GradeType = GradeType = {}));
var CurvatureType;
(function (CurvatureType) {
    CurvatureType["SharpTurn"] = "SharpTurn";
    CurvatureType["NoSharpTurn"] = "NoSharpTurn";
})(CurvatureType || (exports.CurvatureType = CurvatureType = {}));
var IntersectionApproachType;
(function (IntersectionApproachType) {
    IntersectionApproachType["Shared"] = "Shared";
    IntersectionApproachType["SeparateOrNA"] = "SeparateOrNA";
})(IntersectionApproachType || (exports.IntersectionApproachType = IntersectionApproachType = {}));
var NumberOfLanesType;
(function (NumberOfLanesType) {
    NumberOfLanesType["OnePerDirection"] = "OnePerDirection";
    NumberOfLanesType["MoreThanOnePerDirection"] = "MoreThanOnePerDirection";
})(NumberOfLanesType || (exports.NumberOfLanesType = NumberOfLanesType = {}));
var PedestrianFlowType;
(function (PedestrianFlowType) {
    PedestrianFlowType["None"] = "None";
    PedestrianFlowType["Low"] = "Low";
    PedestrianFlowType["MediumToHigh"] = "MediumToHigh";
})(PedestrianFlowType || (exports.PedestrianFlowType = PedestrianFlowType = {}));
var BicycleAndLVFlowType;
(function (BicycleAndLVFlowType) {
    BicycleAndLVFlowType["Low"] = "Low";
    BicycleAndLVFlowType["MediumToHigh"] = "MediumToHigh";
})(BicycleAndLVFlowType || (exports.BicycleAndLVFlowType = BicycleAndLVFlowType = {}));
var ProportionOfCargoBikesAndMopedsType;
(function (ProportionOfCargoBikesAndMopedsType) {
    ProportionOfCargoBikesAndMopedsType["LowToModerate"] = "LowToModerate";
    ProportionOfCargoBikesAndMopedsType["ModerateToHigh"] = "ModerateToHigh";
})(ProportionOfCargoBikesAndMopedsType || (exports.ProportionOfCargoBikesAndMopedsType = ProportionOfCargoBikesAndMopedsType = {}));
var SpeedAverageType;
(function (SpeedAverageType) {
    SpeedAverageType["LessThan20kmh"] = "LessThan20kmh";
    SpeedAverageType["MoreThan20kmh"] = "MoreThan20kmh";
})(SpeedAverageType || (exports.SpeedAverageType = SpeedAverageType = {}));
var SpeedDifferentialType;
(function (SpeedDifferentialType) {
    SpeedDifferentialType["LessThan10kmh"] = "LessThan10kmh";
    SpeedDifferentialType["MoreThan10kmh"] = "MoreThan10kmh";
})(SpeedDifferentialType || (exports.SpeedDifferentialType = SpeedDifferentialType = {}));
var HeavyVehicleFlowType;
(function (HeavyVehicleFlowType) {
    HeavyVehicleFlowType["LowOrRestrictedAccess"] = "LowOrRestrictedAccess";
    HeavyVehicleFlowType["MediumToHigh"] = "MediumToHigh";
})(HeavyVehicleFlowType || (exports.HeavyVehicleFlowType = HeavyVehicleFlowType = {}));
